/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import LoginForm from './LoginForm';
import { Container, Row, Col } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import Helmet from 'react-helmet';
import favicon from './img/logo.ico';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Oxente.net';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => parameters.client_id && parameters.redirect_uri && parameters.response_type

  return (
    <Container fluid={true} className="oxe-body">
      <Helmet>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <div className="row h-100">
        <div className="col-sm-12 my-auto">
          <Row>
            <Col sm="4"></Col>
            <Col sm="4">
              {
                _validateParams()
                  ? <LoginForm
                    api={api}
                    location={location}
                  />
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
            </Col>
            <Col sm="4"></Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default Login;
